import axiosPrivateInstance from 'middlewares/AxiosInstance'

// Mesmo cuidado do featureFlags: chamada de boot, não deve cair no fluxo de
// refresh/redirect do interceptor.
const fetchLatestVersion = platform =>
  axiosPrivateInstance.get('/app/version', { params: { platform }, skipAuthRetry: true })

export default { fetchLatestVersion }
